import React from 'react';
import { Col } from '../utils/bootstrap';
import { Link } from 'react-router-dom';

const styles = {
  container: {
    backgroundSize: 'cover',
    backgroundPosition: 'center bottom',
    overflow: 'hidden',
    width: '100%',
    height: '25rem',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    cursor: 'pointer',
  }
};

export default class CardLink extends React.Component {
  render() {
    const { img, header, body, link, ...otherProps } = this.props;
    return (
      <Col xs={12} md={6} {...otherProps} className="card-link">
        <div>
          <div style={{ background: `url(${img})`, ...styles.container }} />
          <div style={{
            padding: '2em',
            backgroundColor: 'rgba(0,0,0,0.85)'
          }}>
            <h4 style={{ color: '#5f8ebc' }}>{header}</h4>
            <div>{body}</div>
            {
              link &&
              <Link to={link} className="home-link">
                <div style={{ marginTop: '1em', color: '#BAB9BF' }}>
                  Find out more >
                </div>
              </Link>
            }
          </div>
        </div>
      </Col>
    );
  }
}

export class ImageLink extends React.Component {
  render() {
    const { img, header, body, link, history, ...otherProps } = this.props;
    return (
      <Col xs={6} style={styles.imageContainer} {...otherProps} onClick={() => history.push(link)} className="image-link">
        <img src={img} alt="" />
        <div style={{
          padding: '2em',
          backgroundColor: 'rgba(0,0,0,0.9)',
          flex: 1,
          textAlign: 'left',
        }}>
          <h4>{header}</h4>
          <div>{body}</div>
        </div>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CardLink.js